export default __webpack_public_path__ + "static/media/updates.abdbe567.svg";